// Generated by ReScript, PLEASE EDIT WITH CARE

import * as EventTracker from "./EventTracker.bs.js";
import * as EventTrackerGA4$Catalyst from "../../../node_modules/@porterin/catalyst/src/components/custom/event-tracker-ga4/react-ga4/EventTrackerGA4.bs.js";

function publishEvent(category, action, value, label, non_interaction, param) {
  return EventTrackerGA4$Catalyst.publishEventGa4({
              category: category,
              action: action,
              label: label,
              value: value,
              nonInteraction: non_interaction
            });
}

var publishEventParameter = EventTracker.publishEventParameter;

function publishPageView(path, title, param) {
  return EventTrackerGA4$Catalyst.publishPageviewGa4({
              path: path,
              title: title
            });
}

export {
  publishEvent ,
  publishEventParameter ,
  publishPageView ,
  
}
/* EventTracker Not a pure module */
